<script>
	// Stores
	import { 
		linkMapa,
		linkWaze,
		linkUber,
		linkAV, 
		linkAPI, 
		tagsSEO, 
		textEndereco, 
		textAtendimento, 
		textCNPJ, 
		textCreci, 
		textSite, 
		todosContatos, 
		linkFacebook,
		linkInstagram,
		linkYoutube,
		linkLinkedin,
		linkWhatsappLocacao,
		textWhatsappLocacao,
		textWhatsappProposta,
		linkWhatsappProposta,
		linkPoliticaPrivacidade
	} from '../store.js';

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	let localizacao = [
		{
			title: 'Mapa',
			icon: '<i class="fas fa-map-marked-alt"></i>',
			link: $linkMapa,
		},
		{
			title: 'Waze',
			icon: '<i class="fab fa-waze"></i>',
			link: $linkWaze,
		},
		{
			title: 'Uber',
			icon: '<i class="fab fa-uber"></i>',
			link: $linkUber,
		},
	];
</script>

<section class="footer-barra-flutuante">
	<div class="">
		<div class="flex flex-center flex-wrap sm-flex-column gap-5">

			<div class="footer-banner__item">
				<b>Proposta de administração</b>
			</div>

			<div class="footer-banner__item">
				<span class="button text-center">
					<a target="_blank" href="{$linkWhatsappProposta}" title="Proposta via Whatsapp" class="btn btn-primary"><i class="fab fa-whatsapp"></i> {$textWhatsappProposta}</a>
				</span>
			</div>

			<div class="footer-banner__item hidden-sm hidden-xs">
				ou
			</div>

			<div class="footer-banner__item">
				<span class="button text-center">
					<a href="/solicite-proposta" title="Solicite uma proposta" class="btn btn-primary"><i class="fal fa-envelope-open-dollar"></i> Solicite aqui</a>
				</span>
			</div>

			<div class="footer-banner__item hidden-sm hidden-xs">
				|
			</div>
			
			<div class="footer-banner__item hidden-md hidden-lg">
				<br>
			</div>			

			<div class="footer-banner__item">
				<b>Anuncie seu imóvel</b>
			</div>
			
			<div class="footer-banner__item">
				<span class="button text-center">
					<a target="_blank" href="{$linkWhatsappLocacao}" title="Anuncie via Whatsapp" class="btn btn-primary"><i class="fab fa-whatsapp"></i> {$textWhatsappLocacao}</a>
				</span>
			</div>

			<div class="footer-banner__item hidden-sm hidden-xs">
				ou
			</div>

			<div class="footer-banner__item">
				<span class="button text-center">
					<a href="/anuncie" title="Anuncie seu imóvel" class="btn btn-primary"><i class="fal fa-laptop-house"></i> Anuncie aqui</a>
				</span>
			</div>			

		</div>
	</div>
</section>
<footer>
	<section class="footer-banner">
		<div class="container">
			<div class="flex sm-flex-column sm-flex-center gap-10" style="width: 100%;">
				<div class="flex-1 mb-30 mt-30 logo">
					<img src="/assets/images/logoFooter_2.png" border="0" alt="Logotipo" />
				</div>
				<div class="atendimento">
					<h4>Horário de atendimento <i class="fal fa-clock"></i></h4>
					<p>{@html $textAtendimento}</p>
				</div>
				<div class="flex-1 telefones">
					{#each $todosContatos as contato}
					<div class="phone">
						<h4>{contato.title}<span class="hidden-sm hidden-xs">&nbsp;-</span></h4> <a target="_blank" href="{contato.href}">{@html contato.icon} {contato.phone}</a>
					</div>
					{/each}
				</div>
			</div>
		</div>
	</section>
	<section class="informacoes">
		<div class="container">
			<div class="content flex sm-flex-column sm-flex-center">
				<div class="seo">
					<p>{@html $tagsSEO}</p>
					<div class="social flex sm-flex-center gap-10" style="font-size: 24px;">
						<a title="Facebook" href={$linkFacebook} target="_blank"><i class="fab fa-facebook-square"></i></a>
						<a title="Instagram" href={$linkInstagram} target="_blank"><i class="fab fa-instagram"></i></a>
						<a title="YouTube" href={$linkYoutube} target="_blank"><i class="fab fa-youtube"></i></a>
						<a title="Linkedin" href={$linkLinkedin} target="_blank"><i class="fab fa-linkedin"></i></a>
					</div>
				</div>
				<div class="flex-1 localizacao">
					<h4>Localização <i class="fal fa-map-marker-alt"></i></h4>
					<p>{@html $textEndereco}</p>
					<div class="travel flex gap-10 pb-20">
						<a href={$linkMapa} target="_blank"><i class="fal fa-map-marked-alt"></i> Mapa</a>
						<a href={$linkWaze} target="_blank"><i class="fab fa-waze"></i> Waze</a>
						<a href={$linkUber} target="_blank"><i class="fab fa-uber"></i> Uber</a>
					</div>
					<a class="text-smaller" href={$linkPoliticaPrivacidade} target="_blank">Política de Privacidade</a>
				</div>
				<div class="sede">
					<img src="/assets/images/rodapeSede.jpg" alt="Sede da Bona Imóveis" />
				</div>
			</div>
			<div class="copyright">
				<copy>@ 2022 - Bona Imóveis - CRECI {$textCreci} - CNPJ {$textCNPJ} - Todos os direitos reservados - Desenvolvido por <a href="{$linkAPI}" target="_blank" title="API - Tecnologia digital resultados reais">API</a></copy>
			</div>
		</div>
	</section>
</footer>